export const OnboardingSteps = {
  ShipBobGoodFit: 'ShipBobGoodFit',
  ShippingHazmat: 'ShippingHazmat',
  StoreSelection: 'StoreSelection',
  CostCalculator: 'CostCalculator',
  CantShipWithUs: 'CantShipWithUs'
}

export const ActiveOnboardingSteps = [
  OnboardingSteps.ShipBobGoodFit,
  OnboardingSteps.ShippingHazmat,
  OnboardingSteps.StoreSelection,
  OnboardingSteps.CostCalculator,
  OnboardingSteps.CantShipWithUs
]
